import { render } from "./Usuarios.vue?vue&type=template&id=3bc5c04e&scoped=true"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"

import "./Usuarios.vue?vue&type=style&index=0&id=3bc5c04e&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc5c04e"]])

export default __exports__